export enum EBuildingGatesType {
  Ramp = 1,
  Dock = 2,
  Ground = 3,
}
